// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // firebase: {
  //   apiKey: "AIzaSyAE0y6lk9IRn-VXnYvmn2OkeL4cHLzjVc8",
  //   authDomain: "jreapp-5390b.firebaseapp.com",
  //   databaseURL: "https://jreapp-5390b.firebaseio.com",
  //   projectId: "jreapp-5390b",
  //   storageBucket: "jreapp-5390b.appspot.com",
  //   messagingSenderId: "835283225653",
  //   appId: "1:835283225653:web:805a816bb43216152ab57c"
  // }
  // firebase: {
  //   apiKey: "AIzaSyBocygZJl2wSb6WDIxY8hd1P1QaOQG7MV8",
  //   authDomain: "concours-ee-f7708.firebaseapp.com",
  //   projectId: "concours-ee-f7708",
  //   storageBucket: "concours-ee-f7708.appspot.com",
  //   messagingSenderId: "127638422181",
  //   appId: "1:127638422181:web:187c2ab6aadd3fc32a834c"
  // }
    firebase: {
      apiKey: "AIzaSyC4hcq6LGc80j01er9SfpKVc5SJcnFR-K4",
      authDomain: "ecoecoles-app-9654f.firebaseapp.com",
      databaseURL: "https://ecoecoles-app-9654f.firebaseio.com",
      projectId: "ecoecoles-app-9654f",
      storageBucket: "ecoecoles-app-9654f.appspot.com",
      messagingSenderId: "455380500842",
      appId: "1:455380500842:web:b1ad13cc41923ef790a513"
      // apiKey: 'AIzaSyBxMHIYjd8W5JhEQVcaLxE6qq938YcxhXs',
      // authDomain: 'ecoecoles-app-preprod.firebaseapp.com',
      // databaseURL: 'https://ecoecoles-app-preprod.firebaseio.com',
      // projectId: 'ecoecoles-app-preprod',
      // storageBucket: 'ecoecoles-app-preprod.appspot.com',
      // messagingSenderId: '154738244617',
      // appId: '1:154738244617:web:b682011447c85214398cd8',
      // measurementId: 'G-8V1FF7XFCM',
    },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
